import type { MessengerFeatureConfig } from '../type';

export const messenger: Partial<MessengerFeatureConfig> = {
    includeUserNameInMessageBody: true,
    extendedAllowedAttachmentExtensions: ['rtf', 'ppt', 'pptx'],
    totalAttachmentsSizeLimitInMBs: 150,
    maximumAttachmentSizeLimitInMBs: 50,
};
